import { render, staticRenderFns } from "./SettingsTextStyle.vue?vue&type=template&id=2ae38ebd&"
import script from "./SettingsTextStyle.vue?vue&type=script&lang=js&"
export * from "./SettingsTextStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports